var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',_vm._l((_vm.data),function(item,index){return _c('tr',{key:index,class:[_vm.stripe && 'stripe', _vm.rowClassName]},_vm._l((_vm.columns),function(cItem,cIndex){return _c('td',{key:cIndex,style:({
      'min-width': cItem['min-width'],
      'max-width': cItem['max-width']
    }),attrs:{"width":cItem.width,"align":cItem.align}},[_vm._v(_vm._s(item[cItem.prop]))])}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }